/* contentloader.js: Intercept all links on the page and
		load the content for internal links
		directly into the target element */

import $ from 'jquery';
import gaia from 'gaia';


var isExternal = new RegExp('^(?:[a-z]+:)?//', 'i');

var initialState = { 'originalDestination': location.pathname };
history.pushState(initialState, "", location.href);

function loadDestination(destination, options) {
	var loadedPromise = $.Deferred();

	var originalURL = location.href;

	if(options.force || !isExternal.test(destination)) {

		var newDestination = '/content' + destination;

		if(destination === '/') {
			newDestination = newDestination + 'root';
		}

		// TODO: Error checking
		$.get(newDestination, function(data) {
			$('.content').empty().append(data);

			$(window).scrollTop(0);

			if(destination === '/') {
				$('nav.navbar').removeClass('navbar-force');
				gaia.checkScrollForTransparentNavbar();
			}
			else {
				$('nav.navbar').addClass('navbar-force');
				gaia.checkScrollForTransparentNavbar();
			}

			gaia.updateParallaxCache();

			var title = destination.substring(1).replace(/\//g, ' - ').replace(/_/g, ' ');
			document.title = "Paul war's – " + title;

			if(options.pushState != false) {
				var state = { 'originalDestination': destination };
				history.pushState(state, "", destination);
			}

			loadedPromise.resolve();
		}).fail(function() {
			loadedPromise.reject();
		});

		return loadedPromise.promise();
	}
}


export function init() {
	window.onpopstate = function(event) {
		var destination = document.location;
		if(typeof(event.state.originalDestination) !== 'undefined') {
			destination = event.state.originalDestination;
		}

		loadDestination(destination, {
			force: true,
			pushState: false
		});
	};

	$('body').on('click', 'a', function(event) {
		var target = $(event.target);
		if(!target.is('a')) {
			target = target.parents('a');
		}

		var destination = target.attr('href');

		// don't try to load random empty <a> tags
		if(destination.length === 0) {
			return;
		}

		// ignore links with certain rel="" attributes
		if(
			(typeof(target.attr('rel')) !== 'undefined' && target.attr('rel').match(/(external|download)/i)) ||
			target.attr('target') === '_blank'
		) {
			return;
		}

		event.preventDefault();

		// close the menu
		if(gaia.misc.navbar_menu_visible == 1) {
			$('.navbar-toggle').click();
		}


		loadDestination(destination, false)
			// has it worked?
			.fail(function() {
				// Load by hand
				window.location.href = destination;
			});


		return false;
	});
}



//////////////////
// WEBPACK FOOTER
// ./public/js/~/contentloader.js
// module id = 2
// module chunks = 0